import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service'; 
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 
declare var $: any; 
@Component({
  templateUrl: './routeCoverReport.component.html',
})

export class  routeCoverReportComponent{
  address:any
  public prjId: any
  public userId: any
  public startDate: any
  public endDate: any
  public defaultStartDate: any
  public defaultEndDate: any
  public dataRangeModal: any
  public showLoader: boolean
  public vtsDailyCountData: any  

  public vehStopList: any  
  public vtsDataNotFound=false  

  public data :any;

  public search:any;
  public selectedRow : Number;
  currentDateModal:any;
  defStartDt:any;
  defEndDt:any;
  dateRange:any;
  geocoder:any;
  latLngDataList:any;
    VCdate: any;
  constructor(private http : HttpClient , private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    }); 
    var date = new Date();   
    this.currentDateModal=date;
    this.defStartDt = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate(); 
    this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dateRange= {beginDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()},endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}}; 
    }

    

   
    getVehicleStopReport(selectedDate) {
      this.loaderService.display(true); 
      this.http.get(environment.apiUrl + 'reports/vehicles/getRouteCoverageReport?DEVICEDATE='+selectedDate+"&PRJID="+this.prjId).subscribe(Wdata => {
      this.vehStopList  = Wdata
  
      this.data = [] ;
       
     console.log('63',this.vehStopList.length);
     
      
      if (this.vehStopList.length > 0){  

        for (let index = 0; index < this.vehStopList.length; index++) {
          this.data.push({
        
            VehicleNumber :this.vehStopList[index].VEHNO,
            IMEI :this.vehStopList[index].IMEI,
            OWNERNAME:this.vehStopList[index].OWNERNAME,
            OWNERTYPE:this.vehStopList[index].OWNERTYPE,
            TotalStops:this.vehStopList[index].countNumb,
            RouteCoveragePercentage:this.vehStopList[index].countNumb+this.vehStopList[0].countNumb*10/100+"%"
           
          })
  
          
        }
        





          this.loaderService.display(false);
          this.vtsDataNotFound=false
      } else { 
          this.loaderService.display(false);
          this.vtsDataNotFound=true
      }

      console.log('93',this.data);
      
    },
      error => {
          this.loaderService.display(false);
          Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
          })
      })
      
      ;
  }


 
  orgValueChange(date){  


    this.VCdate = date
    this.startDate = moment( this.VCdate ).format('YYYY-MM-DD'); 
    this.getVehicleStopReport(this.startDate)
  }



  importVehicleStopReport(data){
   const ws_name = 'vehicleStopReport';
   const wb: WorkBook = { SheetNames: [], Sheets: {} };
   const ws: any = utils.json_to_sheet(data);
   wb.SheetNames.push(ws_name);
   wb.Sheets[ws_name] = ws;
   const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
   saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'routeCoverReport.xlsx');
   }s2ab(s){
       const buf = new ArrayBuffer(s.length);
       const view = new Uint8Array(buf);
       for (let i = 0; i !== s.length; ++i) {
       view[i] = s.charCodeAt(i) & 0xFF;
       };
       return buf;
   }  
    

  
 

    ngOnInit() {
      this.prjId = this.auth.getAuthentication().projectId
      this.userId = this.auth.getAuthentication().id
      this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD'); 
      this.getVehicleStopReport(this.startDate);
      this.geocoder = new google.maps.Geocoder; 
  }


  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }


  


}


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/routeCoverReport.component.ts